import cache from './portal-cache'
import file from './file'
import subcontent from './subcontent'
import role from './role' //권한추가

export default { cache, file, subcontent, role } //role 추가
